// Test console notice for build workflow verification
document.addEventListener('DOMContentLoaded', () => {
  console.log('🚀 Build workflow test - Abogados Whitley site loaded successfully!');

  // Log the build time to the console
  // This can be useful for debugging and ensuring the build process is working as expected
  // Note: This will log the time when the script is executed, not the actual build time
  const buildTime = new Date().toLocaleString();
  console.log(`Build executed at: ${buildTime}`);

  // Function to calculate and set scrollbar width as a CSS variable
  const updateScrollbarWidth = () => {
    document.body.style.setProperty('--scrollbar-width', window.innerWidth - document.documentElement.clientWidth + 'px');
  };

  // Set initial scrollbar width
  updateScrollbarWidth();

  // Update the scrollbar width variable on window resize
  window.addEventListener('resize', updateScrollbarWidth);
});

// Function to handle accordion active states
function handleAccordionActiveStates() {
  // Select all accordion items
  const accordionItems = document.querySelectorAll('.accordion-item');

  // Check if there are any accordion items
  if (accordionItems.length) {
    // Loop through each accordion item
    accordionItems.forEach(item => {
      // Find the collapse element within the accordion item
      const collapse = item.querySelector('.collapse');

      // If the collapse element exists, add event listeners
      // to manage the active class based on collapse state
      if (collapse) {
        // Add active class when accordion item is shown
        collapse.addEventListener('show.bs.collapse', () => {
          item.classList.add('active');
        });

        // Remove active class when accordion item is hidden
        collapse.addEventListener('hide.bs.collapse', () => {
          item.classList.remove('active');
        });
      }
    });
  }
}

// Initialize functions on page load
document.addEventListener('DOMContentLoaded', () => {
  // Initialize the accordion active states
  handleAccordionActiveStates();
});

// Floating labels for form controls
jQuery(document).on('click focus', '.floating-labels-form .control-wrap .form-control', function () {
  let elm = jQuery(this);
  elm.parents('.control-wrap').addClass('not-empty');
});

// Remove floating label when input is blurred and empty
jQuery(document).on('blur', '.floating-labels-form .control-wrap .form-control', function () {
  let elm = jQuery(this),
    control_wrap = elm.parents('.control-wrap');
  if (elm.val()) control_wrap.addClass('not-empty');else control_wrap.removeClass('not-empty');
});

// Trigger blur on all form controls to set initial state
jQuery(document).ready(function () {
  jQuery('.floating-labels-form .control-wrap .form-control').trigger('blur');
});
